/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { bool, func } from 'prop-types';
import { Box, Drawer, useMediaQuery } from '@mui/material';

// Utils
import { PTO_STATUS } from '../utils';

// Components
import FilterIdentifierPanel from './filter-identifier-panel/FilterIdentifierPanel.connector';
import SwimlaneTopBar from './swimlane/top-bar/TopBar.connector';
import ViewFilterDrawer from './view-filter-drawer/ViewFilterDrawer.connector';
import Swimlane from './swimlane/Swimlane.connector';

const OpenPTOs = props => {
  const statuses = ['approvalNeeded', 'pendingApproval', 'approved', 'scheduled', 'rejected'];

  const { fetchOpenPTOs, filterDrawerOpen, setFilterDrawerOpen } = props;

  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'), { noSsr: true });

  // fetch data on mount
  useEffect(() => {
    const fetchData = async () => {
      await fetchOpenPTOs();
    };
    fetchData();
  }, [fetchOpenPTOs]);

  return (
    <Box
      component="section"
      sx={{
        backgroundColor: 'surface.light',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        paddingTop: { lg: 10.5 },
        width: '100%',
      }}
    >
      <SwimlaneTopBar />
      {lgUp && <FilterIdentifierPanel />}
      <Box
        sx={{
          '@media (max-width: 900px)': {
            paddingTop: theme => theme.spacing(17),
            scrollMarginLeft: theme => theme.spacing(2.5),
            width: '100%',
          },
          '@media (min-width: 1200px)': {
            padding: theme => theme.spacing(5.5, 3, 3),
            width: '100%',
          },
          '@media (min-width: 800px) and (max-width: 1024px)': {
            overflow: 'visible',
            padding: theme => theme.spacing(18, 3, 0),
          },
          backgroundColor: 'surface.light',
          display: 'flex',
          flexWrap: 'nowrap',
          height: '100%',
          justifyContent: 'flex-start',
          minHeight: 'calc(100vh - 72px)',
          overflow: 'auto',
          scrollSnapType: 'x mandatory',
          width: '100vw',
        }}
      >
        {statuses.map(status => (
          <Swimlane key={status} swimlaneType={PTO_STATUS[status]} />
        ))}
      </Box>
      <Drawer
        anchor="right"
        onClose={() => setFilterDrawerOpen(false)}
        open={filterDrawerOpen}
        sx={{
          '& .MuiDrawer-paper': {
            borderRadius: '4px 0 0 4px',
            width: 252,
          },
        }}
      >
        <ViewFilterDrawer />
      </Drawer>
    </Box>
  );
};

OpenPTOs.propTypes = {
  fetchOpenPTOs: func.isRequired,
  filterDrawerOpen: bool.isRequired,
  setFilterDrawerOpen: func.isRequired,
};

export default OpenPTOs;
